import React from 'react';
import { Box, Typography } from '@mui/material';
import SearchInput from '../../../components/searchInput';
import ToggleWhatsHotOnly from '../../../components/toggleWhatsHotOnly';
import TogglePill from '../../../components/togglePill';
import * as styles from './styles';

function DirectorySearch({
    industries = [],
    activeIndustries = [],
    searchText = '',
    whatshotEnabled = false,
    totalCount = 0,
    filteredCount = 0,
    onSearchText,
    onToggleWhatshot,
    onToggleIndustry,
    onClearIndustries,
}) {
    function renderTopRow() {
        return (
            <Box sx={styles.topRow}>
                <SearchInput
                    value={searchText}
                    onChange={onSearchText}
                />
                <ToggleWhatsHotOnly
                    active={whatshotEnabled}
                    count={industries.length}
                    onClick={() => onToggleWhatshot(!whatshotEnabled)}
                />
            </Box>
        );
    }

    function renderCategoryPills() {
        return (
            <Box sx={styles.pillsRow}>
                {industries.map((cat) => (
                    <TogglePill
                        key={cat}
                        label={cat}
                        active={activeIndustries.includes(cat)}
                        onClick={() => onToggleIndustry(cat)}
                    />
                ))}
                {activeIndustries.length > 0 && (
                    <Box component="button" onClick={onClearIndustries} sx={styles.clearButton}>
                        Clear filters
                    </Box>
                )}
            </Box>
        );
    }

    function renderResultsCount() {
        return (
            <Typography sx={styles.resultsCount}>
                Showing{' '}
                <Box component="span" sx={styles.resultsHighlight}>{filteredCount}</Box>
                {' '}of {totalCount} publishers
            </Typography>
        );
    }

    return (
        <Box sx={styles.card}>
            {renderTopRow()}
            {renderCategoryPills()}
            {renderResultsCount()}
        </Box>
    );
}

export default DirectorySearch;
